import PptxGenJS from "pptxgenjs";
import {
  map,
  meanBy,
  pick,
  round,
  flatMap,
  take,
  orderBy,
  takeRight,
  reduce,
} from "lodash";
import {
  COLORS,
  getMediaContent,
  getScoreTableRows,
  TEXT_OPTIONS,
} from "../masters/components";
import { TemplateData } from "..";

const RIGHT_COLUMN_X = 8;
const LEFT_COLUMN_X = 0.52;
const CONTENT_Y = 1.52;

export const addExecutivePotentialSlide = (
  pres: PptxGenJS,
  data: TemplateData
) => {
  const slide = pres.addSlide({ masterName: "SPLIT_LEFT_MASTER" });

  slide.addText("Executive Potential", { placeholder: "title" });

  if (data.candidateName) {
    slide.addText(data.candidateName, {
      ...TEXT_OPTIONS.caption,
      x: LEFT_COLUMN_X,
      y: 1.14,
      fontSize: 18,
    });
  }

  const executivePotentialEvaluations = pick(data.evaluationRows, [
    "Growth Potential",
    "Growth Factors",
    "Potential Realization",
  ]);

  const executivePotentialSummaries = flatMap(
    executivePotentialEvaluations,
    (rows) => rows?.map((row) => row.summary)
  ).filter((s) => s !== "");

  slide.addText(
    map(executivePotentialSummaries, (s) => ({
      text: s,
      options: { ...TEXT_OPTIONS.bullet },
    })),
    {
      ...TEXT_OPTIONS.bullet,
      x: LEFT_COLUMN_X,
      y: CONTENT_Y,
      w: 6.5,
      h: 6,
    }
  );

  const groupRows = [
    {
      groupTitle: "Growth Factors",
      rows: flatMap(
        pick(data.evaluationRows, ["Growth Potential", "Growth Factors"]),
        (rows, groupTitle) =>
          rows?.map((row) => ({
            title: row.title,
            score: round(meanBy(row.evaluations, "evaluation"), 0),
          }))
      ),
    },
    {
      groupTitle: "Potential Realization",
      rows: flatMap(
        pick(data.evaluationRows, ["Potential Realization"]),
        (rows, groupTitle) =>
          rows?.map((row) => ({
            title: row.title,
            score: round(meanBy(row.evaluations, "evaluation"), 0),
          }))
      ),
    },
  ];

  const tableData = [
    ...flatMap(groupRows, (group) => getScoreTableRows(group as any)),
  ];

  const tableOptions = {
    x: RIGHT_COLUMN_X,
    y: CONTENT_Y,
    w: 7.3,
    h: 7.57,
    fontSize: 12,
    colspan: 5,
    rowH: 0.58,
    colW: [2.94, 1.13, 1.13, 1.13, 1.13],
  } as const;

  slide.addTable(tableData as any, tableOptions as any);
};
